import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import withDragAndResize from 'withDragAndResize';

const ACTIVE_POPUP_Z_INDEX = 9999;

const withSelfServeDragAndResize = (WrappedComponent, withDragAndResizeProps = {}) => {
  const WrappedComponentWithDragAndResize = withDragAndResize(
    WrappedComponent,
    withDragAndResizeProps,
  );
  class WrappedComponentWithSelfServeDragAndResize extends React.PureComponent {
    constructor(props) {
      super(props);

      this.isActive = this.isActive.bind(this);
      this.isActiveGroup = this.isActiveGroup.bind(this);
      this.onAttributesChanged = this.onAttributesChanged.bind(this);
    }

    onAttributesChanged(id, attributes) {
      if (this.props.groupId && this.props.activeGroupId !== this.props.groupId) {
        this.props.setActiveGroup(this.props.groupId);
      }
      this.props.onAttributesChanged(id, attributes);
    }

    isActive() {
      if (this.props.activeGroupId) {
        return this.isActiveGroup();
      }
      return this.props.activePopup === this.props.id;
    }

    isActiveGroup() {
      if (!this.props.activeGroupId) {
        return false;
      }
      const popupGroup = this.props.popupGroups[this.props.activeGroupId];
      if (!popupGroup) return false;
      const fieldIds = popupGroup.fieldIds;
      return fieldIds.includes(this.props.id);
    }

    render() {
      let zIndex = this.isActive() ? ACTIVE_POPUP_Z_INDEX : this.props.zIndex;
      if (this.props.isDragging) {
        zIndex = ACTIVE_POPUP_Z_INDEX;
      }
      let zoomFactor = this.props.zoomFactor;
      if (!this.props.isPreviewMode) {
        zoomFactor = 1;
      }
      return (
        <WrappedComponentWithDragAndResize
          {...this.props}
          height={this.props.height * zoomFactor}
          onAttributesChanged={this.onAttributesChanged}
          useTranslate3D
          width={this.props.width * zoomFactor}
          x={this.props.x * zoomFactor}
          y={this.props.y * zoomFactor}
          zIndex={zIndex}
        />
      );
    }
  }

  WrappedComponentWithSelfServeDragAndResize.defaultProps = {
    activeGroupId: '',
    activePopup: '',
    children: null,
    className: '',
    groupId: '',
    isDragging: false,
    isPreviewMode: false,
    popupGroups: {},
    setActiveGroup: () => null,
    zIndex: 1,
    zoomFactor: 1,
  };
  WrappedComponentWithSelfServeDragAndResize.propTypes = {
    activeGroupId: PropTypes.string,
    activePopup: PropTypes.string,
    groupId: PropTypes.string,
    height: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    isDragging: PropTypes.bool,
    isPreviewMode: PropTypes.bool,
    onAttributesChanged: PropTypes.func.isRequired,
    popupGroups: CustomPropTypes.hashmapOf(
      PropTypes.shape({
        label: PropTypes.string,
        type: PropTypes.string,
        pageIndex: PropTypes.number,
        fieldIds: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
    setActiveGroup: PropTypes.func,
    width: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    zIndex: PropTypes.number,
    zoomFactor: PropTypes.number,
  };

  return WrappedComponentWithSelfServeDragAndResize;
};

export default withSelfServeDragAndResize;



// WEBPACK FOOTER //
// ./src-react/withSelfServeDragAndResize/index.jsx